<template>
    <svg t="1659318225317" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2268" width="200" height="200">
        <path d="M826.709333 529.749333L374.485333 831.232A21.333333 21.333333 0 0 1 341.333333 813.482667V210.517333a21.333333 21.333333 0 0 1 33.152-17.749333l452.224 301.482667a21.333333 21.333333 0 0 1 0 35.498666z"
            p-id="2269" fill="#ffffff"></path>
    </svg>
</template>
